export default __webpack_public_path__ + "static/media/loan-origination-system.433739d7.png";